export default __webpack_public_path__ + "static/media/008-search.bbce75f8.svg";